export default __webpack_public_path__ + "static/media/chip_100.8499a071.svg";